import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationService, UserService } from '@core';
import { DigitsGroupingPipe } from '../pipes';

@Component({
  selector: 'lib-price-and-points',
  templateUrl: './price-and-points.component.html',
  styleUrl: './price-and-points.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DigitsGroupingPipe],
})
export class PriceAndPointsComponent {
  protected readonly rewardName = inject(ConfigurationService).rewardName;
  showBoth = input<boolean>(false);
  price = input<number>();
  points = input<number>();
  delimiter = input<'and' | 'or'>('and');
  highlightTotal = input<boolean>(false);
  /**
   * Admin-panel keeps the US dollar / points split. The storefront shows one amount in Shopping Dollars:
   * `price` (card part) + `points` (Shopping Dollar part), since one Shopping Dollar is one US dollar.
   */
  showUsd = input<boolean>(false);

  protected readonly shoppingDollars = computed(() => (this.price() ?? 0) + (this.points() ?? 0));

  protected readonly canRedeemPoints = inject(UserService).canRedeemPoints;
}
